<template>
    <div>
        <div v-if="totalItems > 0">
            <div class="margin-bottom-10">
                <button class="btn btn-xs btn-outline dark" @click="loadPrevPreview()" :disabled="options.prevUrl === null">
                    <i class="glyphicon glyphicon-arrow-left"></i> {{ $lang.get('trans.previous') }}
                </button>
                <button class="btn btn-xs btn-outline dark pull-right" @click="loadNextPreview()"
                        :disabled="options.nextUrl === null">
                    {{ $lang.get('trans.next') }} <i class="glyphicon glyphicon-arrow-right"></i>
                </button>
            </div>
            <pdf-preview :filename="options.filename"> </pdf-preview>
        </div>
        <div v-else>
            <error-state :text="$lang.get('trans.error_missing_items')"></error-state>
        </div>
    </div>

</template>

<script>
    import PdfPreview from './PdfPreview'
    import ErrorState from 'components/global/ErrorState'

    export default {
        name: "pdf-preview-manager",

        props: ['initialOptions'],

        data() {
            return {
                options: null,
                previewHistory: [],
                crtPreview: 0,
                totalItems: null,
                loading: false
            }
        },

        components: {
            PdfPreview,
            ErrorState
        },

        methods: {
            async loadNextPreview() {
                if (typeof this.previewHistory[this.crtPreview + 1] !== 'undefined') {
                    this.options = this.previewHistory[++this.crtPreview]

                    return
                }

                eventBus.$emit('show-spinner');
                try {
                    let response = await axios.get(this.options.nextUrl)
                    this.options = response.data
                    this.savePreviewToHistory(++this.crtPreview)
                } catch (error) {
                    this.$toaster.error("There was a error loading the preview")
                    console.log(error)
                }
                eventBus.$emit('hide-spinner');
            },

            async loadPrevPreview() {
                if (typeof this.previewHistory[this.crtPreview - 1] !== 'undefined') {
                    this.options = this.previewHistory[--this.crtPreview]

                    return
                }

                eventBus.$emit('show-spinner');
                try {
                    let response = await axios.get(this.options.prevUrl)
                    this.options = response.data
                    this.savePreviewToHistory(--this.crtPreview)
                } catch (error) {
                    this.$toaster.error("There was a error loading the preview")
                    console.log(error)
                }
                eventBus.$emit('hide-spinner');
            },

            savePreviewToHistory(index) {
                this.previewHistory[index] = this.options
            }
        },

        beforeMount() {
            this.options = this.initialOptions
            this.totalItems = Sincron.totalItems
            this.savePreviewToHistory(this.crtPreview)
        }
    }
</script>
